var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown-viewer',{model:{value:(_vm.getMarkdown),callback:function ($$v) {_vm.getMarkdown=$$v},expression:"getMarkdown"}})}
var staticRenderFns = []

export { render, staticRenderFns }